import React from 'react';
import Hero from './components/college-list/Hero';
import Main from './components/college-list/Main';

const CollegeList = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default CollegeList;